import { Variant } from "~/components/newsletter/newsletter-widget/enums";
import { findFirstNonEmptyString } from "~/lib/utils";
export const getNewsletterTitle = newsletterItem => findFirstNonEmptyString(newsletterItem === null || newsletterItem === void 0 ? void 0 : newsletterItem.alternativeName, newsletterItem === null || newsletterItem === void 0 ? void 0 : newsletterItem.name);
export const getTriggerPoint = variant => {
  switch (variant) {
    case Variant.AcquisitionNewsletterPopup:
      return "ppto";
    case Variant.Article:
      return "article inline";
    case Variant.Footer:
      return "footer inline";
    case Variant.Topic:
      return "topic inline";
    case Variant.NewsletterList:
      return "newsletter index";
    case Variant.Homepage:
      return "homepage inline";
    case Variant.NewsletterArticle:
      return "newsletter article";
    case Variant.NewsletterArticleBottom:
      return "newsletter article";
  }
  return "newsletter index";
};